import { useTranslation } from 'react-i18next';
import AccountTerminationModalBase from '@/components/ModalRenderer/components/components/AccountTerminationModalBase';

const NoRemainingDebtInfo = () => {
  const { t } = useTranslation('Modal');

  return (
    <AccountTerminationModalBase
      title={t('NoRemainingDebtInfo.title')}
      buttonText={t('NoRemainingDebtInfo.action')}
    >
      <p>{t('NoRemainingDebtInfo.info')}</p>
    </AccountTerminationModalBase>
  );
};

export default NoRemainingDebtInfo;
